import { SIGNOUT_SUCCESS, SIGNIN_SUCCESS, AUTH_ERROR, SET_AUTH_LOADING } from "./types";

export const signInAction = data => {
  return {
    type: SIGNIN_SUCCESS,
    payload: data
  };
};

export const signOutAction = data => {
  return {
    type: SIGNOUT_SUCCESS,
};
};

export const authErrorAction = data => {
  return {
    type: AUTH_ERROR,
    payload:data
  };
};

export const setAuthLoading = data => {
  return {
    type: SET_AUTH_LOADING,
    payload:data
  };
};
